export default __webpack_public_path__ + "static/media/p3.b1f2f9c0.gif";